export default "__VITE_ASSET__79387bdb__"